export const NORMAL_BORDER_WIDTH = 2;
export const ACTIVE_BORDER_WIDTH = 5;

export const GRID_COLOR = '#aaaaaa44';

export const crossPanelLinkingOptions = {
  scenario: {text: 'By scenario', attributes: ['scen_id']},
  model: {text: 'By model', attributes: ['model_id']},
  variable: {text: 'By variable', attributes: ['variable']},
  unit: {text: 'By unit', attributes: ['unit']},
  region: {text: 'By region', attributes: ['region']},
  version: {text: 'By version', attributes: ['version']},
};
export const crossPanelLinkingOptionsList = Object.entries(crossPanelLinkingOptions)
  .map(([value, opts]) => ({value, ...opts}));

export const defaultChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {display: false},
};

export const emptyMapping = {
  years: [],
  columnDefs: [],
  rowData: [],
  data: {datasets: [], labels: []},
  options: defaultChartOptions,
};

export const pointStyles = [
  'circle',
  'triangle',
  'rect',
  'rectRounded',
  'rectRot',
  'star',
  'cross',
  'crossRot',
  'dash',
  'line',
];

export const showOptions = [
  {text: 'Line chart', value: 'chart-line', icon: 'line-chart'},
  {text: 'Bar chart', value: 'chart-bar', icon: 'bar-chart'},
  {text: 'Table', value: 'table', icon: 'tablet'},
];
